document.addEventListener("DOMContentLoaded", function () {
    const openTrigger = document.querySelector(".Guarantee_Form_Pop-up");
    const overlay = document.getElementById("GuaranteePopupOverlay");
    // Bail out cleanly on pages without the guarantee popup markup.
    if (!openTrigger || !overlay) return;
    const closeBtn = overlay.querySelector(".guarantee-close");

    openTrigger.addEventListener("click", function () {
      overlay.style.display = "flex";
      document.body.classList.add("guarantee-popup-open");
    });

  
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        overlay.style.display = "none";
        document.body.classList.remove("guarantee-popup-open");
      });
    }

   
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        overlay.style.display = "none";
        document.body.classList.remove("guarantee-popup-open");
      }
    });
  });
  